import * as AddCustomerOrderFailed from '@ori-events/add-customer-order-failed';
import { RequestUrl } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';
export async function addCustomerOrderHandler({
  detail: {
    orderIds,
    placement
  }
}) {
  const url = new URL(RequestUrl.AddCustomerOrder, window.location.href);
  orderIds.forEach(id => url.searchParams.append('orderIds', String(id)));
  const response = await fetch(url.toString(), getHttpRequestSettings({
    placement
  }));
  const data = convertToCamelCase(await response.json());
  if (AddCustomerOrderFailed.isAddCustomerOrderErrorResponse(data)) {
    const errorEvent = new CustomEvent(AddCustomerOrderFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return {
    ...data,
    lastAddedCustomerOrderIds: orderIds
  };
}
//# sourceMappingURL=addCustomerOrderHandler.js.map